import React from 'react';
import { Button, DialogActions, Dialog } from '@mui/material';

type Props = {
  isOpen: boolean;
  closeButtonLabel?: React.ReactNode;
  onRequestClose?: () => void;
  actions?: React.ReactNode[];
  onClose?: () => void;
  maxWidth?: false | 'md' | 'xs' | 'sm' | 'lg' | 'xl' | undefined;
  children: React.ReactNode,
}

const GenericDialog: React.FC<Props> = ({
  actions,
  onRequestClose,
  maxWidth = 'md',
  closeButtonLabel,
  onClose,
  isOpen,
  children,
}: Props) => {
  let allActions: React.ReactNode[] = [];
  if (closeButtonLabel) {
    allActions.push(
      (
        <Button
          variant="contained"
          // className="mt2 ml2 mr2"
          onClick={onClose}
          color="secondary"
          key="closebutton"
          sx={{ mx: 0.5 }}
        >
          {closeButtonLabel}
        </Button>
      ),
    );
  }
  if (actions && actions.length > 0) {
    allActions = allActions.concat(actions);
  }

  return (
    <Dialog
      onClose={onRequestClose}
      scroll="paper"
      open={isOpen}
      maxWidth={maxWidth}
      fullWidth
    >
      {children}
      {
        allActions
        && allActions.length > 0
        && (
          <DialogActions>
            {allActions}
          </DialogActions>
        )
      }
    </Dialog>
  );
};

export default GenericDialog;
